import { CinematicStep } from '../../types';
import { cloudinaryImage, cloudinaryStaticPoster, cloudinaryVideoPreview } from '../../shared/cloudinary';

const ASSET_BASE = 'd741c0fc08c4b708d02d9ccd7a69c7a9-1772740262';

export const CINEMATIC_TITLE = 'Advanced creative technology, guided by professional vision.';
export const CINEMATIC_SUBTITLE =
    'From cinematic commercials to UGC, our AI Video Directors bring specialized expertise across a wide range of categories.';

export const CINEMATIC_STEPS: CinematicStep[] = [
    {
        id: 'ads-commercial',
        title: 'Advertisements',
        videoUrl: cloudinaryVideoPreview(`${ASSET_BASE}993/ai-video-category-ads`, 'w_500'),
        posterUrl: cloudinaryStaticPoster(`${ASSET_BASE}993/ai-video-category-ads`, 500),
    },
    {
        id: 'animation-pixar',
        title: 'Animations',
        imageUrl: cloudinaryImage(`${ASSET_BASE}975/ai-video-category-animation.png`, 400),
    },
    {
        id: 'ugc-content',
        title: 'UGC Content',
        videoUrl: cloudinaryVideoPreview(`${ASSET_BASE}983/ai-video-category-ugc`, 'w_500'),
        posterUrl: cloudinaryStaticPoster(`${ASSET_BASE}983/ai-video-category-ugc`, 500),
    },
    {
        id: 'short-film',
        title: 'Short Films',
        imageUrl: cloudinaryImage(`${ASSET_BASE}991/ai-video-category-short-film.png`, 400),
    },
    {
        id: 'music-video',
        title: 'Music Video',
        videoUrl: cloudinaryVideoPreview(`${ASSET_BASE}990/ai-video-music-video`, 'w_500'),
        posterUrl: cloudinaryStaticPoster(`${ASSET_BASE}990/ai-video-music-video`, 500),
    },
    {
        id: 'gaming',
        title: 'Gaming',
        videoUrl: cloudinaryVideoPreview(
            '6cfd89bbce2e590731e700af94e4a29a-1773130823518/ai-video-category-gaming-2',
            'w_500'
        ),
        posterUrl: cloudinaryStaticPoster(
            '6cfd89bbce2e590731e700af94e4a29a-1773130823518/ai-video-category-gaming-2',
            500
        ),
    },
    {
        id: 'cartoon',
        title: 'Cartoons',
        imageUrl: cloudinaryImage(`${ASSET_BASE}973/ai-video-category-cartoon.png`, 400),
    },
    {
        id: 'movie-trailer',
        title: 'Movie Trailers',
        videoUrl: cloudinaryVideoPreview(
            'f744bc6d4f91f010659aab5346a8df37-1773130884505/ai-video-category-movie-trailer-2',
            'w_500'
        ),
        posterUrl: cloudinaryStaticPoster(
            'f744bc6d4f91f010659aab5346a8df37-1773130884505/ai-video-category-movie-trailer-2',
            500
        ),
    },
    {
        id: 'educational-content',
        title: 'Educational Content',
        videoUrl: cloudinaryVideoPreview(`${ASSET_BASE}974/ai-video-category-educational`, 'w_500'),
        posterUrl: cloudinaryStaticPoster(`${ASSET_BASE}974/ai-video-category-educational`, 500),
    },
];

export const CINEMATIC_CTA_TEXT = 'Contact our production team';
